module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/Direction/components/Building/images/attack-bomber-squadrons-lvl2-50.057e5170.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/Direction/components/Building/images/attack-bomber-squadrons-lvl2-50.png
// module id = 3292
// module chunks = 11